// AudioListener3D.tsx
// Mounts a THREE.AudioListener on the R3F default camera
// This is a prerequisite for any future THREE.PositionalAudio usage

import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import * as THREE from 'three';

const AudioListener3D: React.FC = () => {
  const { camera } = useThree();

  useEffect(() => {
    const listener = new THREE.AudioListener();
    camera.add(listener);
    return () => {
      camera.remove(listener);
    };
  }, [camera]);

  return null;
};

export default AudioListener3D;
